import { useEffect, useState } from "react";
import { Input, Stack, Text, YStack } from "tamagui";
import { validateTaiwanPhone } from "@components/form/validate/vaildateTaiwanPhone";
import { kiosk } from "../kioskTheme";
import { KioskCTA } from "./KioskParts";

/** 聯絡電話底部輸入 sheet（數字鍵盤、台灣手機驗證）。 */
const PhoneSheet = ({
  isOpen,
  initial,
  onClose,
  onSave,
}: {
  isOpen: boolean;
  initial: string;
  onClose: () => void;
  onSave: (v: string) => void;
}) => {
  const [val, setVal] = useState(initial);
  useEffect(() => {
    if (isOpen) setVal(initial);
  }, [isOpen, initial]);
  if (!isOpen) return null;
  const ok = validateTaiwanPhone(val);
  return (
    <Stack position="absolute" t={0} l={0} r={0} b={0} backgroundColor="rgba(17,32,58,.45)" jc="flex-end" style={{ zIndex: 100 }} onPress={onClose}>
      <YStack
        className="kiosk-sheetin"
        backgroundColor="#fff"
        borderTopLeftRadius={24}
        borderTopRightRadius={24}
        px={18}
        pt={8}
        pb={24}
        onPress={(e: any) => e.stopPropagation?.()}>
        <Stack alignSelf="center" width={40} height={5} borderRadius={3} backgroundColor="#dfe3ec" my={10} />
        <Text fontSize={20} fontWeight="800" color={kiosk.ink} mb={4}>
          聯絡電話
        </Text>
        <Text fontSize={13} color={kiosk.grey} mb={16}>
          外送員聯絡用
        </Text>
        <Input
          value={val}
          onChangeText={(t: string) => setVal(t.replace(/[^\d]/g, "").slice(0, 10))}
          inputMode="numeric"
          placeholder="09xxxxxxxx"
          borderWidth={1.5}
          borderColor={kiosk.line}
          borderRadius={12}
          backgroundColor="#fff"
          color={kiosk.ink}
          fontSize={18}
          h={54}
        />
        <Stack mt={18}>
          <KioskCTA label="儲存" disabled={!ok} onPress={() => onSave(val)} />
        </Stack>
      </YStack>
    </Stack>
  );
};

export default PhoneSheet;
